import { TextInput, type TextInputProps } from "@mantine/core"

type LoginTextInputProps = TextInputProps & {
  name: string
  label: string
  placeholder: string
  onSubmit?: () => void
}

export const LoginTextInput = ({
  name,
  label,
  placeholder,
  onSubmit,
  ...props
}: LoginTextInputProps) => {
  return (
    <TextInput
      name={name}
      label={label}
      fz="md"
      fw={400}
      labelProps={{
        fz: "md",
        fw: 400,
        mb: "var(--mantine-spacing-xs)",
      }}
      style={{
        "&::placeholder": {
          color: "red",
        },
      }}
      styles={{
        input: {
          borderTop: "none",
          borderLeft: "none",
          borderRight: "none",
          borderRadius: "0",
          fontSize: "var(--mantine-font-size-sm)",
          borderBottom: "1px solid var(--mantine-color-walnut-8)",
          "&::placeholder": {
            color: "red",
          },
        },
      }}
      placeholder={placeholder}
      onKeyDown={(e) => {
        if (e.key === "Enter" && onSubmit) {
          e.preventDefault()
          onSubmit()
        }
      }}
      {...props}
    />
  )
}
